<template>
   <div class="home">
     <h1>Home</h1>
   </div>
</template>


<script>

   export default {
      data(){
         return {
            booking_date: (new Date).toISOString().substring(0,10),
         }
      },
      metaInfo: {
         title: 'Lovaue - Fashion Collective',
         meta: [{ name: "description", content:'A site that displays the latest fashion styles' }]
      },
      computed: {
      },
      methods:{

      }
   }
</script>
